<style>
.el-collapse-item__header {
  padding-left: 15px;
}

.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}

.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}

.v-modal {
  z-index: 100 !important;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.management-list {
  display: flex;
  align-items: center;
  /* margin-bottom: 15px; */
}

.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 20px;
}

.management-name {
  flex-shrink: 0;
}

.designee {
  padding: 3px 10px 6px 10px;
  display: inline-block;
  border: 1px solid grey;
  box-sizing: border-box;
  line-height: 20px;
  margin-left: 10px;
}

.input-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 25px;
}

.input-item .input-title {
  margin-right: 14px;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">任务名称</div>
          <el-input v-model="page.taskContentName" size="mini" class="ipt-sty" placeholder="请输入任务名称"></el-input>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
    </div>

    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'" >
      <div class="button-area">
        <el-button icon="el-icon-plus" size="mini" type="info" @click="addVersion">新增任务名称</el-button>
      </div>
      <el-table :data="tableData" stripe border style="width: 100%" v-loading="tableLoading" :height="height">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="taskType" label="任务大类" show-overflow-tooltip header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.taskType ||'-'}}</template>
        </el-table-column> -->
        <el-table-column prop="taskContentName" label="任务名称" show-overflow-tooltip header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.taskContentName }}</template>
        </el-table-column>
        <el-table-column prop="menuName" label="关联菜单功能" show-overflow-tooltip header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.menuName || '-' }}</template>
        </el-table-column>

        <el-table-column prop="createUserName" label="创建人" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createUserName }}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
        </el-table-column>
        <el-table-column prop="updateUserName" label="更新人" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateUserName||'-' }}</template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateTime | getDate }}</template>
        </el-table-column>
        <el-table-column prop="bank" width="120px" label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="editVersion(scope.row)">编辑 ｜</a>
            <a class="txt-color" @click="delVersion(scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination class="pt pb back-color-fff content-pagination-box" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange"   :page-sizes="[10,20,50,100,200]" :current-page="page.pageIndex"
      :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination>
    <el-dialog :title="textTitle" :visible.sync="dialogVisible" width="600px">
      <el-form label-width="140px" :label-position="right" class="demo-ruleForm">
        <!-- <el-form-item>
          <span slot="label" style="color: white">*</span>
          <span slot="label">任务大类 </span>
          <el-select v-model="taskType" clearable filterable placeholder="请选择任务大类" style="width: 400px; float: left">
            <el-option v-for="item in taskClassList" :key="item.paramName" :label="item.paramName"
              :value="item.paramName"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">任务名称 </span>
          <el-input type="input" style="width: 400px; float: left" :maxlength="30" placeholder="请输入任务名称"
            v-model="taskContentName">
          </el-input>
        </el-form-item>
        <div class="management-list" style="margin-left: 46px">
          <div class="management-name">关联菜单功能</div>
          <div>
            <span class="designee mb10" v-show="departmentData !== '' || departmentData !== null"
              v-for="(item, index) in departmentData" :key="index"><span class="select-name">{{ item.menuName }}</span>
              <span @click="delDepartmentSingle(index)" class="ml10 cursor-sty font-S19">×</span></span>
            <span class="select-department" @click="
              dialogMenuVisible = true; filterText = ''; ">{{ departmentData && departmentData.length > 0 ? '修改' : '选择关联菜单' }}</span>
          </div>
        </div>
        <el-form-item style="margin-top: 20px">
          <span slot="label">任务类型 </span>
          <el-select v-model="taskContentType" filterable placeholder="请选择任务类型" style="width: 400px; float: left"
            @change="handleTaskContentType">
            <el-option v-for="(item, indx) in taskContentTypeList" :key="indx" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="客户类型"
          v-if="
            taskContentType == 'BHOTC' ||
            taskContentType == 'BHSY' ||
            taskContentType == 'SCDY' ||
            taskContentType == 'JPXXSJ' ||
            taskContentType == 'SQSH' ||
            taskContentType == 'KCXXCJ' ||
            taskContentType == 'TKYL' ||
            taskContentType == 'CPPS' ||
            taskContentType == 'HCSJRK' ||
            taskContentType == 'SSGT' ||
            taskContentType == 'THCL' ||
            taskContentType == 'TSGL' ||
            taskContentType == 'XCPPX' ||
            taskContentType == 'SWQT'||
            taskContentType == 'BHRX' ||
            taskContentType == 'KHDK' ||
            taskContentType == 'YYJD' ||
            taskContentType == 'TZYDJD' ||
            taskContentType == 'WDCGDD' ||
            taskContentType == 'WDXSDD' ||
            taskContentType == 'CGTHDD' ||
            taskContentType == 'XSTHDD' ||
            taskContentType == 'YWCL' ||
            taskContentType == 'JDSYGS' 
          "
        >
          <el-select style="width: 400px; float: left" v-model="clientObject" placeholder="选择任务执行时针对的对象，可多选" filterable
            class="fl" multiple>
            <el-option v-for="item in clientObjectList" :key="item.value" :label="item.text" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item  v-if="taskContentType == 'SCDY'||taskContentType == 'HYLB'||taskContentType == 'ZXHY'">
          <span slot="label">城市等级
            <el-tooltip class="item" effect="dark">
              <div slot="content" style="overflow: hidden;">
                表示该任务按客户所在城市的等级来执行和核算
              </div>
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
          <el-select style="width: 400px; float: left" v-model="cityLevel" placeholder="请选择城市等级" filterable
            class="fl" multiple @focus="focusCityOrRemote(1)">
            <el-option v-for="item in cityLevelList" :key="item.value" :label="item.text" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item  v-if="taskContentType == 'SCDY'||taskContentType == 'BHRX'||taskContentType == 'YYJD'">
          
          <span slot="label">
            <el-tooltip class="item" effect="dark">
            <div slot="content" style="overflow: hidden;">
              表示该任务仅支持所选等级的医院来执行任务
            </div>
            <i class="el-icon-question"></i>
          </el-tooltip>
            医院等级
          </span>
          <div class="addMed-class" v-for="(obj,index) in orgGrade">
            <el-select style="width: 120px; float: left" v-model="obj.orgRank" placeholder="医院等级" filterable
            class="fl">
              <el-option v-for="item in medLevelList" :key="item.value" :label="item.text" :value="item.value"></el-option>
            </el-select>
            <el-select style="width: 120px; float: left;padding:0 10px;" v-model="obj.orgGrade" placeholder="医院等次" filterable
              class="fl">
              <el-option v-for="item in getCodeListByKey('医院等次')" :label="item.text" :value="item.value" :key="item.guid"></el-option>
            </el-select>
            <span  @click="delItem(obj,index)">删除</span>
          </div>
          <div class="addMed-class" @click="addItem">
            <!-- <img src="../../assets/icon/circle-plus.png" alt="">
            <span >添加等级</span> -->
            <el-button  size="small" icon="el-icon-circle-plus-outline" plain @click="addItem">添加等级</el-button>
          </div>
         
          
          <!-- <el-select style="width: 400px; float: left" v-model="medLevel" placeholder="请选择医院等级" filterable
            class="fl" multiple>
            <el-option v-for="item in medLevelList" :key="item.value" :label="item.text" :value="item.value"></el-option>
          </el-select> -->
           
        </el-form-item>
        <!-- <el-form-item  v-if="taskContentType == 'SCDY'||taskContentType == 'BHRX'||taskContentType == 'YYJD'">
          <span slot="label">机构等次
            <el-tooltip class="item" effect="dark">
              <div slot="content" style="overflow: hidden;">
               表示该任务仅支持所选等次的机构来执行任务
              </div>
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
          <el-select style="width: 400px; float: left" v-model="orgGrade" placeholder="请选择机构等次" filterable
            class="fl" multiple>
            <el-option v-for="item in getCodeListByKey('医院等次')" :label="item.text" :value="item.value" :key="item.guid"></el-option>
          </el-select>
          <el-cascader placeholder="请选择医院等级" style="width: 400px; float: left"  v-model="medLevel" 
              :options="medLevelList" clearable :props="cascaderProps" filterable></el-cascader>
           
        </el-form-item> -->

        <el-form-item  v-if="taskContentType == 'TZYDJD'" label="药店类型">
          <el-select style="width: 400px; float: left" v-model="customerTypeJson" placeholder="请选择药店类型" filterable
            class="fl" multiple>
            <el-option v-for="item in customerTypeList" :key="item.value" :label="item.text" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item  v-if="taskContentType == 'BHRX'" label="器械分类">
          <el-select style="width: 400px; float: left" v-model="deviceCategory" placeholder="请选择" filterable
            class="fl" multiple>
            <el-option v-for="item in apparatusList" :key="item.guid" :label="item.dicName" :value="item.guid"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="margin-bottom:10px;"  v-if="taskContentType == 'BHRX'||taskContentType == 'BHOTC'||taskContentType == 'BHSY'" >
          <span slot="label">
            <el-tooltip class="item" effect="dark">
              <div slot="content" style="overflow: hidden;">
                表示该任务仅支持选择竞品报货或者非竞品报货
              </div>
              <i class="el-icon-question"></i>
            </el-tooltip>
            是否竞品
          </span>
          <el-radio-group v-model="isCompetitor" class="radio-content" style="width: 400px; float: left;line-height:48px;text-align: left">
            <el-radio label="Y">是</el-radio>
            <el-radio label="N">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item style="margin-bottom:10px;"  v-if="taskContentType == 'SCDY'" >
          <span slot="label">客户偏远地区</span>
          <el-select style="width: 400px; float: left" v-model="isRemote" placeholder="请选择" filterable
            class="fl" clearable @focus="focusCityOrRemote(2)">
            <el-option v-for="item in getCodeListByKey('客户偏远地区')" :key="item.value" :label="item.text" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item  v-if="taskContentType == 'SQSH'" label="工作事项">
          <el-select style="width: 400px; float: left" v-model="workContentJson" placeholder="请选择工作事项" filterable
            class="fl" multiple>
            <el-option v-for="item in workContentList" :key="item.value" :label="item.text" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item  v-if="taskContentType == 'CPPS'" label="配送区域">
          <el-select style="width: 400px; float: left" v-model="distributionArea" placeholder="选择配送区域，可多选" filterable
            class="fl" multiple>
            <el-option v-for="item in distributionAreaList" :key="item.value" :label="item.text" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="会议类型" v-if="taskContentType == 'HYLB'||taskContentType == 'ZXHY'">
          <el-select style="width: 400px; float: left" v-model="meetingType" placeholder="请选择会议类型" filterable
            class="fl" multiple>
            <el-option v-for="item in meetingTypeList" :key="item.value" :label="item.text" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="margin-bottom:10px;" >
          <span slot="label" style="color: red">*</span>
          <span slot="label">任务执行角色 </span>
          <el-checkbox-group v-model="checkList" style="width: 410px; float: left">
            <el-checkbox label="领导者（例：总监、省总)"></el-checkbox>
            <el-checkbox label="业务执行者（例：业务员）"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="支持企业派发"  >
          <el-radio-group v-model="isAllowTenantUse" class="radio-content" style="width: 400px; float: left;line-height:48px;text-align: left">
            <el-radio label="Y">支持</el-radio>
            <el-radio label="N">不支持</el-radio>
          </el-radio-group>
        </el-form-item>


      </el-form>
      


      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="dialogVisible = false">取 消</el-button>
        <el-button size="medium" type="info" v-if="textTitle == '新增任务名称'" @click="addReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading">确 定</el-button>
        <el-button size="medium" type="info" v-else @click="updateReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading">修 改</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选择关联菜单" :visible.sync="dialogMenuVisible" width="50%" center>
      <div class="select-box">
        <div class="box-left fl" style="width: 100%; border: 0 none">
          <div style="margin-bottom: 20px">
            菜单搜索：<el-input v-model="filterText" class="ipt-sty mt15" placeholder="请输入菜单搜索"></el-input>
          </div>
          <el-tree v-if="dialogMenuVisible" :data="treeDataList" show-checkbox :default-expand-all="false" node-key="guid"
            :check-strictly="true" ref="treeDep" highlight-current :props="defaultProps"
            :filter-node-method="filterNodeDep" @check-change="handleCheckChange" @node-click="nodeClick">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ data.menuName }}<span class="remark-class" v-if="data.remark"> ({{ data.remark }}）</span></span>
            </span>
          </el-tree>
        </div>
      </div>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="dialogMenuVisible = false">取消</el-button>
        <el-button size="medium" type="info" @click="sureMenu">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    return {
      contentMainHeight: window.innerHeight - 200,
      fullscreenLoading: false,
      textTitle: '新增任务名称',
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        taskContentName: '',
        tenantGuid: localStorage.guid,
      },
      taskContentType: '',
      taskType: '',
      taskContentName: '',
      isAllowTenantUse:null,
      height: window.innerHeight - 260,
      right: 'right',
      tableData: [],
      dialogVisible: false,
      dialogMenuVisible: false,
      treeDataList: [],
      defaultProps: {
        children: 'children',
        label: `menuName`,
      },
      defaultExpandAndll: false,
      filterText: '',
      departmentData: [],
      taskClassList: [],
      taskContentTypeList: [],
      clientObjectList: [],
      clientObject: [],
      checkList: ['领导者（例：总监、省总)','业务执行者（例：业务员）'],
      cityLevel: [],//城市等级
      cityLevelList: [
        // { text: '一线城市', value: 0 },
        // { text: '新一线城市', value: 1 },
        // { text: '二线城市', value: 2 },
        // { text: '三线城市', value: 3 },
        // { text: '四线城市', value: 4 },
        // { text: '五线城市', value: 5 },
        // { text: '六线城市', value: 6 }
      ],
      medLevel: [],//医院等级
      orgGrade:[//机构等次
        {
          orgRank:null,
          orgGrade:null,
        }
      ],
      medLevelList: [
        // { text: '非等级', value: 0 },
        // { text: '一级', value: 1 },
        // { text: '二级', value: 2 },
        // { text: '三级', value: 3 }
      ],
      isCompetitor: 'N',//是否竞品
      isRemote:null,//客户偏远地区
      meetingType:[],//会议类别
      meetingTypeList:[
      // { text: '三员会', value: '1' },
      // { text: '科室会', value: '3' },
      // { text: '招商会', value: '4' },
      // { text: '学术沙龙会', value: '5' },
      // { text: '培训会', value: '6' },
      // { text: '其他会议', value: '2' },
      // { text: '圆桌会', value: '8' },
      ],

      distributionArea:[],
      distributionAreaList:[],
      customerTypeJson:[],//终端类型
      customerTypeList:[],
      deviceCategory:[], //器械分类
      apparatusList:[],
      workContentJson:[],//工作事项
      workContentJsonList:[],
      taskLabelList:[],
      taskLabelListList:[],
      taskLabel:'',
      cascaderProps: { //角色级联
        value: 'value',
        label: 'text',
        children: 'childDictList',
        multiple: true, 
        checkStrictly: true,
        emitPath:false
      },
    };
  },
  created() {
    this.getAllProduct();
    this.getList();
    this.getTaskClassList();
    this.getContentTypeList();
    //获取城市等级字典
    this.getLevelList(1);
    //获取医院等级字典
    this.getLevelList(2);
    //获取会议类型字典
    this.getLevelList(3);
    //获取配送区域
    this.getLevelList(4);
    //获取药店类型
    this.getLevelList(5);
    //获取售前售后-工作事项
    this.getLevelList(6);
    //获取标签并创建大类
    // this.getLabelOrCreate();
    // 获取器械分类列表
    this.getApparatusList();
  },
  watch: {
    filterText(val) {
      this.$refs.treeDep.filter(val);
    },
  },
  methods: {
    handleTaskContentType() {
      let clientObject = [];
      // if (this.taskContentType == 'XSHY') {
      //   this.checkList = ['领导者（例：总监、省总)'];
      // } else {
      //   this.checkList = ['业务执行者（例：业务员）'];
      // }
      //竞品信息收集”、“客户拜访”、“库存信息收集”、“拓客引流”、“售前/售后、产品配送、耗材上架入库、手术跟台、退货处理
      this.isCompetitor = 'N';
      this.isRemote = null;//客户偏远地区
      this.meetingType = [];
      this.cityLevel = [];
      this.medLevel = [];
      this.orgGrade = [];
      if (
        this.taskContentType == 'BHOTC' ||
        this.taskContentType == 'BHSY' ||
        this.taskContentType == 'SCDY' ||
        this.taskContentType == 'JPXXSJ' ||
        this.taskContentType == 'SQSH' ||
        this.taskContentType=='KCXXCJ' ||
        this.taskContentType=='TKYL' ||
        this.taskContentType=='CPPS' ||
        this.taskContentType=='HCSJRK' ||
        this.taskContentType=='SSGT' ||
        this.taskContentType=='THCL' ||
        this.taskContentType=='TSGL' ||
        this.taskContentType=='XCPPX' ||
        this.taskContentType=='SWQT'||
        this.taskContentType=='BHRX'||
        this.taskContentType=='KHDK'||
        this.taskContentType=='YYJD'||
        this.taskContentType=='TZYDJD'||
        this.taskContentType=='WDCGDD'||
        this.taskContentType=='WDXSDD'||
        this.taskContentType=='CGTHDD'||
        this.taskContentType=='XSTHDD'||
        this.taskContentType=='YWCL'||
        this.taskContentType == 'JDSYGS'
      ) {
        this.fullscreenLoading = true;
        let taskContentType=this.taskContentType;
        if(taskContentType=='CGTHDD'){
          taskContentType='FKSCGTHD';
        }else if(taskContentType=='XSTHDD'){
          taskContentType='FKSXSTHD';
        }
        this.api.get(`/${serverConfig.msSalesPerformService}/dict/data/get-dict?functionCode=${taskContentType}`).then((resp) => {
          this.fullscreenLoading = false;
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = resp.data.data;
            this.clientObjectList = data;
            data.forEach(item=>{
              clientObject.push(item.value)
            })
            this.clientObject=clientObject;
          }
        });
      }else{
        this.clientObject=[];
      }
    },
    getCustomerType(code) {
      let that = this;
      this.fullscreenLoading = true;
      if(code=='CGTHDD'){
        code='FKSCGTHD';
        }else if(code=='XSTHDD'){
          code='FKSXSTHD';
        }
      this.api.get(`/${serverConfig.msSalesPerformService}/dict/data/get-dict?functionCode=${code}`).then((resp) => {
          this.fullscreenLoading = false;
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = resp.data.data;
            that.clientObjectList = data;
          }
        });
    },
    getContentTypeList() {
      let that = this;
      that.api.get(`/${serverConfig.msConfigureService}/sysparameter/data/get-detail-grp?tenantGuid=${localStorage.guid}&code=RWLX`).then((resp) => {
          console.log(resp.data);
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = resp.data.data;
            let arr = [];
            data.forEach((item) => {
              arr.push({
                name: item.name,
                value: item.parameterValue,
              });
            });
            that.taskContentTypeList = arr;
          }
        });
    },
    getTaskClassList() {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        bizType: '任务大类',
        tenantGuid: localStorage.guid,
        tenantName: JSON.parse(localStorage.userInfo).tenantName,
      };
      self.tableLoading = true;

      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, req).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.taskClassList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    sureMenu() {
      var list = this.$refs.treeDep.getCheckedNodes();
      setTimeout(() => {
        this.dialogMenuVisible = false;
      }, 100);
      this.departmentData = list;
      console.log(list);
    },
    delDepartmentSingle(index) {
      this.departmentData.splice(index, 1);
      this.departmentList = this.departmentData;
    },
    handleCheckChange(data, checked, node) {
      if (checked == true) {
        this.checkedId = data.guid;
        this.$refs.treeDep.setCheckedNodes([data]);
      }
    },
    focusCityOrRemote(flg){
      let msg='城市等级和客户偏远地区不能同时选择'
      if((flg==1&&this.isRemote)||(flg==2&&this.cityLevel.length>0)){
        this.$message.warning(msg)
      }
      if(this.isRemote){
        
      }
    },
    nodeClick(data, checked, node) {
      this.checkedId = data.guid;
      this.$refs.treeDep.setCheckedNodes([data]);
    },
    filterNodeDep(value, data) {
      if (!value) return true;
      return data.menuName.indexOf(value) !== -1;
    },
    getAllProduct() {
      let self = this;
      this.productList = [];
      this.activeProduct = '';
      self.api
        .postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/product/data/get`, {
          platformGuid: '1e2409b7ef0b412c2bb84e38f8fe50ba',
          pageIndex: 1,
          pageSize: -1,
        })
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.productList = res.data.data.records;
            self.productList.forEach((item) => {
              if (item.productName == '移动端应用') {
                self.getMenu(item.guid);
              }
            });
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getMenu(guid) {
      let self = this;
      let promise = {
        guid: '',
        parentGuid: '',
        platformGuid: '1e2409b7ef0b412c2bb84e38f8fe50ba',
        productGuid: [guid],
      };
      self.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/menu/data/get`, promise).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          var list = res.data.data;
          list.forEach((item) => {
            item.disabled = true;
            if (item.remark) {
              item.menuName = item.menuName;
            }
            if (item.children && item.children.length != 0) {
              item.children.forEach((el) => {
                if (el.remark) {
                  el.menuName = el.menuName;
                }
              });
            }
          });
          self.treeDataList = list;
        }
      });
    },
    // 器械分类
    getApparatusList() {
      let self = this;
      self.apparatusList = [];
      self.api.get(
        `/${serverConfig.msConfigureService}/dict/get-tree-by-dictType?dictType=商品大类字典&dicName=医疗器械管理分类`
      ).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let data = res.data.data;
          self.apparatusList=data[0].childList
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    search() {
      let self = this;
      this.page.pageIndex = 1;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-set/content/get-list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        taskType: '',
        tenantGuid: localStorage.guid,
        tenantName: JSON.parse(localStorage.userInfo).tenantName,
      };
      this.getList();
    },
    addVersion() {
      this.textTitle = '新增任务名称';
      this.taskType = '';
      this.departmentData = [];
      this.taskContentName = '';
      this.isAllowTenantUse = null;
      this.dialogVisible = true;
      this.taskContentType = '';
      this.clientObject = [];
      this.clientObjectList = [];
      this.deviceCategory = [];
    },
    editVersion(detail) {
      console.log('detail',detail);
      
      this.textTitle = '编辑任务名称';
      this.dialogVisible = true;
      this.guid = detail.guid;
      this.taskType = detail.taskType;
      this.taskContentName = detail.taskContentName;
      this.taskContentType = detail.taskContentType;
      this.isAllowTenantUse = detail.isAllowTenantUse;
      if (detail.menuName) {
        this.departmentData = [
          {
            menuName: detail.menuName,
            path: detail.menuUrl,
            guid: detail.menuGuid,
            menuRemark: detail.menuRemark,
          },
        ];
      } else {
        this.departmentData = [];
      }
      this.clientObject = detail.clientObject?JSON.parse(detail.clientObject):[];
      //城市等级
      this.cityLevel = detail.cityLevel?JSON.parse(detail.cityLevel):[];
      //医院等级
      this.medLevel = detail.medLevel?JSON.parse(detail.medLevel):[];
      //机构等次
      this.orgGrade = detail.orgGrade?JSON.parse(detail.orgGrade):[];
      //会议类型
      this.meetingType = detail.meetingType?JSON.parse(detail.meetingType):[];
      //配送区域
      this.distributionArea = detail.distributionArea?JSON.parse(detail.distributionArea):[];
      this.customerTypeJson = detail.customerTypeJson?JSON.parse(detail.customerTypeJson):[];
      this.workContentJson = detail.workContentJson?JSON.parse(detail.workContentJson):[];
      this.deviceCategory = detail.deviceCategory? JSON.parse(detail.deviceCategory):[];
      //标签
      //是否竞品
      this.isCompetitor = detail.isCompetitor=='Y'?'Y':'N';
      //客户偏远地区
      this.isRemote = detail.isRemote;
      // if (detail.clientObject) {
      //   this.getCustomerType(this.taskContentType)
      // }
      this.getCustomerType(this.taskContentType)
      if (!detail.isTeamLeader) {
        this.checkList = ['领导者（例：总监、省总)', '业务执行者（例：业务员）'];
      } else if (detail.isTeamLeader == 'Y') {
        this.checkList = ['领导者（例：总监、省总)'];
      } else if (detail.isTeamLeader == 'N') {
        this.checkList = ['业务执行者（例：业务员）'];
      }
      console.log('detail',detail);
      
    },
    getList() {
      let self = this;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-set/content/get-list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getLevelList(type) {
      let that = this;
      that.api
        .get(
          `/${serverConfig.msConfigureService}/dict/data/get-by-dictType?dictType=${type == 1 ? '城市等级' : type == 2?'医院级别':type == 3?'会议类型':type == 4?'配送区域':type == 5?'终端分类':'售前售后-工作事项'}`,
        )
        .then((resp) => {
          console.log(resp.data);
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = resp.data.data;
            if(type != 5&&type != 6&&type != 2){
              data.forEach(item=>{
                item.value = +item.value;
              })
            }
            type == 1 ? this.cityLevelList = data : type == 2? this.medLevelList = data:type == 3? this.meetingTypeList = data:type == 4? this.distributionAreaList = data:type == 5? this.customerTypeList = data:this.workContentList = data;
          }
        });
    },
    delVersion(guid) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })

        .then(() => {
          self.fullscreenLoading = true;
          self.api
            .postJson(`/${serverConfig.msSalesPerformService}/task-set/content/delete?guid=${guid}`)
            .then((res) => {
              self.fullscreenLoading = false;
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success('删除成功');
                self.page.pageIndex = 1;
                self.getList();
              } else {
                self.$message.error(res.data.msg);
              }
            });
        });
    },
    addReqVersion() {
      var self = this;
      // if (!this.taskType) {
      //   self.$message.error('请选择任务大类');
      //   return;
      // }
      if (!this.taskContentName) {
        self.$message.error('请选择任务名称');
        return;
      }
      if (this.checkList.length == 0) {
        self.$message.error('请选择任务执行角色');
        return;
      }
      if(this.isRemote&&this.cityLevel.length > 0){
        self.$message.error('城市等级和客户偏远地区不能同时选择');
        return;
      }
      console.log(this.departmentData)
      if (this.orgGrade.length > 0) {
        this.orgGrade.forEach((item,idx)=>{
          if(item.orgRank!=0 && item.orgGrade!=0 && !item.orgRank && !item.orgGrade ){
            this.orgGrade.splice(idx,1);
          }
        })
      }
      
      console.log(this.orgGrade,1253)
      console.log(JSON.stringify(this.orgGrade),1253)
      var req = {
        taskType: this.taskType,
        taskContentName: this.taskContentName,
        isAllowTenantUse: this.isAllowTenantUse,
        menuGuid: (this.departmentData && this.departmentData[0] && this.departmentData[0].guid) || '',
        menuName: (this.departmentData && this.departmentData[0] && this.departmentData[0].menuName) || '',
        menuUrl: (this.departmentData && this.departmentData[0] && this.departmentData[0].path) || '',
        taskContentType: this.taskContentType,
        tenantGuid: localStorage.guid,
        tenantName: JSON.parse(localStorage.userInfo).tenantName,
        menuRemark: (this.departmentData && this.departmentData[0] && this.departmentData[0].remark) || '',
        clientObject: this.clientObject.length ? JSON.stringify(this.clientObject) : null,
        isCompetitor:(this.taskContentType == 'BHRX'||this.taskContentType == 'BHOTC'||this.taskContentType == 'BHSY') ? this.isCompetitor : null,
        isRemote: this.taskContentType == 'SCDY'?this.isRemote:null,//客户偏远地区
        medLevel:null,//清空旧的医院等级
        orgGrade: this.orgGrade.length ? JSON.stringify(this.orgGrade) : null,
        cityLevel: this.cityLevel.length ? JSON.stringify(this.cityLevel) : null,
        meetingType: this.meetingType.length ? JSON.stringify(this.meetingType) : null,
        distributionArea: this.distributionArea.length ? JSON.stringify(this.distributionArea) : null,//配送区域
        customerTypeJson: this.customerTypeJson.length ? JSON.stringify(this.customerTypeJson) : null,//终端类型
        deviceCategory: this.deviceCategory.length ? JSON.stringify(this.deviceCategory) : null, //器械分类
        workContentJson: this.workContentJson.length ? JSON.stringify(this.workContentJson) : null,//工作内容
      };
      if (this.checkList.includes('领导者（例：总监、省总)') && this.checkList.includes('业务执行者（例：业务员）')) {
        req.isTeamLeader = '';
      }
      if (!this.checkList.includes('领导者（例：总监、省总)') && this.checkList.includes('业务执行者（例：业务员）')) {
        req.isTeamLeader = 'N';
      }
      if (this.checkList.includes('领导者（例：总监、省总)') && !this.checkList.includes('业务执行者（例：业务员）')) {
        req.isTeamLeader = 'Y';
      }
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-set/content/edit`, req).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('新增成功');
          self.page.pageIndex = 1;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    updateReqVersion() {
      var self = this;
      // if (!this.taskType) {
      //   self.$message.error('请选择任务大类');
      //   return;
      // }

      if (!this.taskContentName) {
        self.$message.error('请选择任务名称');
        return;
      }
      if (this.checkList.length == 0) {
        self.$message.error('请选择任务执行角色');
        return;
      }
      if(this.isRemote&&this.cityLevel.length > 0){
        self.$message.error('城市等级和客户偏远地区不能同时选择');
        return;
      }
      console.log(this.departmentData)
      if (this.orgGrade.length > 0) {
        this.orgGrade.forEach((item,idx)=>{
          if(item.orgRank!=0 && item.orgGrade!=0 && !item.orgRank && !item.orgGrade ){
            this.orgGrade.splice(idx,1);
          }
        })
      }
      console.log(JSON.stringify(this.orgGrade),1253)
      var req = {
        taskType: this.taskType,
        taskContentName: this.taskContentName,
        isAllowTenantUse:this.isAllowTenantUse,
        menuGuid: (this.departmentData && this.departmentData[0] && this.departmentData[0].guid) || '',
        menuName: (this.departmentData && this.departmentData[0] && this.departmentData[0].menuName) || '',
        menuUrl: (this.departmentData && this.departmentData[0] && this.departmentData[0].path) || '',
        guid: this.guid,
        taskContentType: this.taskContentType,
        tenantGuid: localStorage.guid,
        tenantName: JSON.parse(localStorage.userInfo).tenantName,
        menuRemark: (this.departmentData && this.departmentData[0] && this.departmentData[0].remark) || '',
        clientObject :this.clientObject.length?JSON.stringify(this.clientObject):null,
        isCompetitor:(this.taskContentType == 'BHRX'||this.taskContentType == 'BHOTC'||this.taskContentType == 'BHSY') ? this.isCompetitor : null,
        isRemote: this.taskContentType == 'SCDY'?this.isRemote:null,//客户偏远地区
        medLevel:null,//清空旧的医院等级
        orgGrade:this.orgGrade.length?JSON.stringify(this.orgGrade):null,
        cityLevel:this.cityLevel.length?JSON.stringify(this.cityLevel):null,
        meetingType:this.meetingType.length?JSON.stringify(this.meetingType):null,
        distributionArea:this.distributionArea.length?JSON.stringify(this.distributionArea):null,
        customerTypeJson: this.customerTypeJson.length ? JSON.stringify(this.customerTypeJson) : null,//终端类型
        deviceCategory: this.deviceCategory.length ? JSON.stringify(this.deviceCategory) : null, //器械分类
        workContentJson: this.workContentJson.length ? JSON.stringify(this.workContentJson) : null,//工作内容
      };
      if (this.checkList.includes('领导者（例：总监、省总)') && this.checkList.includes('业务执行者（例：业务员）')) {
        req.isTeamLeader = '';
      }
      if (!this.checkList.includes('领导者（例：总监、省总)') && this.checkList.includes('业务执行者（例：业务员）')) {
        req.isTeamLeader = 'N';
      }
      if (this.checkList.includes('领导者（例：总监、省总)') && !this.checkList.includes('业务执行者（例：业务员）')) {
        req.isTeamLeader = 'Y';
      }
      // var clientObject = [];
      // var newClientObject = this.clientObject;
      // if (newClientObject && newClientObject.length != 0) {
      //   newClientObject.forEach((item) => {
      //     clientObject.push({
      //       name: item,
      //     });
      //   });
      //   req.clientObject = JSON.stringify(clientObject);
      // } else {
      //   req.clientObject = null;
      // }
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-set/content/edit`, req).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('修改成功');
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // getLabelOrCreate() {
    //   let that = this;
    //   that.api.get(
    //     `/${serverConfig.msConfigureService}/dict/data/get-by-dictType?dictType=任务标签`,
    //   ).then((resp) => {
    //     const { data } = resp    
    //     console.log(data)    
    //     // 字典分类【任务标签】不存在，则需要新增
    //     if(data.msg!='success') {
    //       that.api.postJson(
    //         `/${serverConfig.msConfigureService}/dict/save-class`,
    //         {
    //           "guid": '',
    //           "dictTypeName": "任务标签",
    //           "orderNum": 0
    //         }
    //       ).then((res) => {
    //       });
    //     }else{
    //       that.api.get( `/${serverConfig.msConfigureService}/dict/data/get-by-dictType?dictType=任务标签`).then((res) => {
    //         let list =  res.data.data||[];
    //         this.taskLabelListList = [];
    //         list.forEach(item=>{
    //           this.taskLabelListList.push(item.text)
    //           console.log( this.taskLabelListList)
    //         })
    //       });
          
    //     }
    //   });
    // },
    // addLable(){
    //   if(!this.taskLabel){
    //     this.$message.error('请填写标签')
    //     return;
    //   }
    //   this.api.postJson(
    //         `/${serverConfig.msConfigureService}/dict/save-dict`,
    //         {
    //           "dicValue": this.taskLabel,
    //           "dicName": this.taskLabel,
    //           "parentName":"任务标签",
    //           "orderNum": 0
    //         }
    //       ).then((resp) => {
    //         if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //           this.taskLabelList.push(this.taskLabel)
    //           this.taskLabel = '';
    //           this.getLabelOrCreate();
    //         }else{
    //           this.taskLabel = '';
    //           this.$message.error(resp.data.msg);
    //         }
    //       });
    // },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    //新增医院等级
    addItem() {
      try {
        this.orgGrade.forEach((item,idx) => {
          console.log('item',item);
          if (item.orgRank!=0 && item.orgGrade!=0 && !item.orgRank && !item.orgGrade ) {
            console.log('item1',item);
            // throw new Error('');
            this.orgGrade.splice(idx, 1);
          }
          
        });
      } catch (e) {
        this.$message.warning(e.message);
        return;
      }
      this.orgGrade.push({
        orgRank: null,
        orgGrade: null,
      });
    },
    //删除医院等级
    delItem(item,index) {
      console.log('delete');
      var self = this;
      self.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.orgGrade.splice(index, 1);
      });
      
    },
  },
};
</script> 
<style scoped lang="less">
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.el-range-editor.el-input__inner {
  padding: 0px;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}

.remark-class {
  color: #b7b7b7;
}

/deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #4fa1a4;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4fa1a4;
  border-color: #4fa1a4;
}
.search-area .search-area-div{
  flex-shrink: 0;
  text-align: right;
  margin-right: 2px;
}
.ipt-sty{
  flex: 1;
}
.el-col-6 {
  display: flex;
}
.addMed-class{
  color: #4fa1a4;
  border-color: #4fa1a4;
  display: flex;
  height: 40px;
  text-align: left;
  align-items: center;
  img{
    width: 16px;
    height: 16px;
    padding-right: 4px;
  }
  .el-button{
    font-size: 14px;
    padding: 7px;
  }
}

</style>